export default __webpack_public_path__ + "665947b1423c233be4d2abb53e74e58b.svg";